module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.isAreaTable) ? _c('div', {
    staticClass: "password-popup"
  }, [_c('div', {
    staticClass: "password-popup-width"
  }, [_c('a', {
    staticClass: "toggle",
    on: {
      "click": _vm.closeAreaTableModal
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Layer_1",
      "x": "0",
      "y": "0",
      "version": "1.1",
      "viewBox": "0 0 29 29",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#706c6c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      "d": "M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "heading_pop"
  }, [_vm._v("Waste Collection Areas of " + _vm._s(_vm.plantName))]), _vm._v(" "), _c('div', {
    staticClass: "table_scroll"
  }, [_c('table', {
    staticClass: "tablePopUp"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tableDataNew), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.areaName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.areaLocation))])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.closeAreaTableModal
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'segregationPlantCreate',
        params: {
          _id: '0'
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn gradientbt"
  }, [_vm._v("Add Segregation Plant")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "segregationTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.action(props.row)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "py-2 text-center row"
        }, [_c('label', {
          staticClass: "toggle"
        }, [_c('input', {
          staticClass: "toggle-checkbox",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": props.row.isActive
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.activateSegregationModal(props.row); }).apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "slider"
        }), _vm._v(" "), _c('span', {
          staticClass: "labels",
          attrs: {
            "data-on": "Active",
            "data-off": "Deactivate"
          }
        })])])])]
      }
    }, {
      key: "wasteCollectionAreaCount",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [(props.row.wasteCollectionAreaCount) ? _c('a', {
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showArea(props.row)
            }
          }
        }, [_vm._v(_vm._s(props.row.wasteCollectionAreaCount))]) : _vm._e(), _vm._v(" "), (!props.row.wasteCollectionAreaCount) ? _c('p', [_vm._v("\n              " + _vm._s(props.row.wasteCollectionAreaCount) + "\n            ")]) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Area Name")]), _vm._v(" "), _c('th', [_vm._v("Area Location")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03aa3edb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/segregationPlant/segregation.vue
// module id = 2258
// module chunks = 1